// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WF-z","hovered":"XF-z","hoverImage":"YF-z","mainImage":"ZF-z","imageNoBackground":"_F-z","fullSizeImage":"aG-z"};